module.exports = __webpack_public_path__ + "customer4.png?aa80dbec7bd0a9c26326053a898df609";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/customer4.png
// module id = 116
// module chunks = 0